import { atom } from 'recoil'
import { ILibraryGroup } from './libraryGroups.types'

interface ILibraryGroupsState {
  loaded: boolean
  items: ILibraryGroup[]
}

const libraryGroupsAtom = atom<ILibraryGroupsState>({
  key: 'libraryGroups',
  default: {
    items: [],
    loaded: false,
  },
})

export default libraryGroupsAtom
